import './App.css';
import React from 'react';
import Header from './common/header/Header';
import Footer from './common/footer/Footer';
import Spinner from './common/spinner/Spinner';
import PrivateRoute from './routes/PrivateRoute';
import PublicRoute from './routes/PublicRoute';
import { Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Posts = React.lazy(() => import('./index/Index'));
const Login = React.lazy(() => import('./login/Login'));
const ShowPost = React.lazy(() => import('./showPost/ShowPost'));
const NewPost = React.lazy(() => import('./newPost/NewPost'));
const EditPost = React.lazy(() => import('./editPost/EditPost'));
const Profile = React.lazy(() => import('./profile/Profile'));
const PageNotFound = React.lazy(() => import('../components/pageNotFound/PageNotFound'));

function App() {

  return (
    <>
      <Header />
      <React.Suspense fallback={<Spinner />}>
        <Switch>
          <Route exact path='/' component={Posts} />
          <PublicRoute path='/login'>
            <Login />
          </PublicRoute>
          <PrivateRoute path='/post/new'>
            <NewPost />
          </PrivateRoute>
          <PrivateRoute path='/post/edit/:id'>
            <EditPost />
          </PrivateRoute>
          <Route path='/profile/:userId' component={Profile} />
          <Route path='/post/:id' component={ShowPost} />
          <Route component={PageNotFound} />
        </Switch>
      </React.Suspense>
      <Footer />
      <ToastContainer autoClose={3000} hideProgressBar />
    </>
  )
}

export default App;
